<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<p class="c-modal__title c-text c-text--xl">{{ vm.title }}</p>
		</div>
		<div class="c-modal__content">
			<div *ngIf="vm.isHtmlContent">
				<div [innerHtml]="vm.content"></div>
			</div>
			<div *ngIf="!vm.isHtmlContent">
				<p>{{vm.content}}</p>
			</div>
		</div>
		<br/>
		<div class="c-modal__footer">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
					<button id="cancelButton" class="c-button c-button--s6 c-button--fit c-button--narrow" (click)="vm.cancel()">{{ vm.cancelText }}</button>
				</div>
				<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
					<button id="acceptButton" class="c-button c-button--s1 c-button--fit c-button--narrow" (click)="vm.submit({ isAccepted: true })">{{ vm.submitText }}</button>
				</div>
			</div>
		</div>
	</div>
</div>
